import { Link } from "react-router";

export function TermsPage() {
  return (
    <section className="page legal-page">
      <h1>Terms of service</h1>
      <p className="muted">
        By using Predabet, you agree to these Terms. If you do not agree, do not
        use the site.
      </p>

      <h2>Entertainment-only service</h2>
      <p>
        Predabet is provided{" "}
        <strong>for research and entertainment purposes only</strong>. It does
        not involve real-money wagering, betting, or prizes on this site.{" "}
        <strong>No guarantees</strong> of outcomes are made, and nothing on this
        site is financial, legal, or betting advice.
      </p>

      <h2>Age requirement</h2>
      <p>
        You must be <strong>18 years or older</strong> to use this site. If you
        are under 18, you may not use or access Predabet.
      </p>

      <h2>Compliance with laws</h2>
      <p>
        Sports betting is regulated and permitted only in select jurisdictions.
        If you use information here to inform real-world decisions, you are
        responsible for complying with <strong>local laws</strong> and any age
        restrictions (often <strong>21+</strong> for regulated sports betting in
        the U.S.). Availability varies by location.
      </p>

      <h2>Accounts</h2>
      <p>
        Sign-in uses Google. You are responsible for maintaining control of your
        device and browser session.
      </p>

      <h2>Acceptable use</h2>
      <ul>
        <li>
          <strong>No abuse</strong>: do not attempt to disrupt the service,
          scrape at high volume, or bypass rate limits.
        </li>
        <li>
          <strong>No misuse</strong>: do not use the service for unlawful
          purposes.
        </li>
      </ul>

      <h2>Disclaimer of warranties</h2>
      <p>
        The service is provided <strong>“as is”</strong> and{" "}
        <strong>“as available”</strong>. We do not warrant that it will be
        uninterrupted, error-free, or accurate.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, the site operator is not liable
        for any losses or damages arising from your use of Predabet.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these Terms from time to time by posting a new version on
        this page.
      </p>

      <p className="muted small" style={{ marginTop: "1rem" }}>
        Back to <Link to="/">Predictions</Link>. See also{" "}
        <Link to="/privacy">Privacy</Link> and{" "}
        <Link to="/responsible-gaming">Responsible gaming</Link>.
      </p>
    </section>
  );
}
